import moment, { Moment } from 'moment';
import { Resources, InexactDurationUnit } from '@erecruit/types';
import { DurationUnit } from '../../types';

export const durationUnitResolutions: DurationUnit[] = [
  {
    value: InexactDurationUnit.Year,
    resolution: 'year',
    messageId: messageIds.vms.general.yearRelative,
  },
  {
    value: InexactDurationUnit.Month,
    resolution: 'month',
    messageId: messageIds.vms.general.monthRelative,
  },
  {
    value: InexactDurationUnit.Week,
    resolution: 'week',
    messageId: messageIds.vms.general.weekRelative,
  },
  {
    value: InexactDurationUnit.Day,
    resolution: 'day',
    messageId: messageIds.vms.general.dayRelative,
  },
];

export const calculateEndDate = (
  startDate: Moment,
  durationAmount: number,
  durationUnit: InexactDurationUnit,
) => {
  const durationResolution = durationUnitResolutions.find(
    du => du.value === durationUnit,
  );

  return moment(startDate).add(
    durationAmount,
    durationResolution?.resolution || 'days',
  );
};

export const getDurationResolution = (durationUnit: InexactDurationUnit) => {
  return durationUnitResolutions.find(
    duration => duration.value === durationUnit,
  );
};

export const findShiftOption = (
  shiftTypes: Resources.ShiftType[],
  startTime: string,
  endTime: string,
) => {
  return shiftTypes.find((element: Resources.ShiftType) => {
    return element.startTime === startTime && element.endTime === endTime;
  });
};

export const getDuration = (
  estimatedStartDate: Moment,
  estimatedEndDate: Moment,
): [number, InexactDurationUnit] => {
  let durationAmount = 1,
    durationUnit = InexactDurationUnit.Day;

  durationUnitResolutions.some(durationResolution => {
    durationAmount = estimatedEndDate
      .clone()
      .startOf('day')
      .diff(
        estimatedStartDate.clone().startOf('day'),
        durationResolution.resolution,
        true,
      );

    if (Number.isInteger(durationAmount)) {
      durationUnit = durationResolution.value;
      return true;
    }

    return false;
  });

  return [durationAmount, durationUnit];
};

export const subtractEndDateFromStartDate = (
  estimatedStartDate?: Moment,
  estimatedEndDate?: Moment,
) => {
  return estimatedStartDate && estimatedEndDate
    ? estimatedEndDate
        .startOf('day')
        .diff(estimatedStartDate.startOf('day'), 'day')
    : 0;
};
